<template>
  <div class="tips">
      <span style="margin-right:15px;" @click="goMessages"><i class="iconfont icon-xiaoxi"></i></span>
      <span v-if="!newsCount"  @click="goMessages"><i class="iconfont icon-lingdang"></i></span>
      <span v-if="newsCount"  @click="goMessages">
          <el-badge :value="newsCount" class="item" style="height: 30px;"><i class="iconfont icon-lingdang" style="position: relative;top: -25px;"></i></el-badge>
      </span>
  </div>
</template>
<script>
export default {
    data() {
        return {
            newsCount:0
        }
    },
    methods: {
        getNoticeList(){
            var params = {
                Action: 'GetNoticeGroupByDate',
                isLook: 0
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                
                this.newsCount = data.length
            }, err => {

            })
        },
        goMessages(){
            this.$router.push({path:'/message'});
            this.newsCount = 0;
        }
    },
    created() {
        
    }
}
</script>
<style scoped>
.tips{
    padding-left: 25px;
}
.tips .iconfont{
    font-size: 25px;
    color: #ccc;
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/tips/tips.vue